import _ from 'lodash'
import { MutationTree } from 'vuex'
import { Nullable } from '@/types/general'
import { REVISION_NEW_SET, REVISION_ADD, REVISION_VIEW } from './constants'
import { Revision, RevisionState } from './types'

const mutations: MutationTree<RevisionState> = {
    /**
     * Reset the list of revisions to track a new entry
     */
    [REVISION_NEW_SET](state, entryId) {
        state.tracking = entryId
        state.revisions = []
    },

    /**
     * Add new revisions to the revision list
     */
    [REVISION_ADD](state, revisions: Revision[]) {
        state.revisions = _(revisions.concat(state.revisions))
            .uniqBy(v => v.id)
            .sortBy(v => v.id, 'asc')
            .value()
    },

    /**
     * Revision view
     */
    [REVISION_VIEW](state, revision: Nullable<Revision>) {
        state.viewing = revision
    }
}

export default mutations
